import script from "./ProfileUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileUser.vue?vue&type=script&setup=true&lang=js"

import "./ProfileUser.vue?vue&type=style&index=0&id=58293ca6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58293ca6"]])

export default __exports__